import invoiceDialog from "./invoiceDialogPt.json";
import cancellationReasonDialog from "./cancellationReasonDialog.json";

export const newOrderDialogs = {
	invoiceDialog,
	cancellationReasonDialog,
};
